/**
 * Created by akrio on 2018/3/23.
 */
import {
  addPost as addPostRes,
  list as listRes,
  postedList as postedListRes,
  delPost as delPostRes,
  removePost as removePostRes,
  postNow as postNowRes,
  editPost as editPostRes,
  getPostBy as getPostByRes,
  approvePostBy as approvePostByRes,
  loginTw as loginTwRes,
} from "../api/post";
import { cropImage } from "../service/media";
import store from "../store/index";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  TIMEZONE,
} from "../store/mutation-types";
import moment from "moment-timezone";
import { Post } from "./model/post";
import Lockr from "lockr";
import { updateUserInfo } from "../service/user";
import { currentName } from "../const/timezone";
import _, { isNil } from "lodash";
import { mulModifyUnlimited } from "./publisher";
import app from "../main";
import { showErrorMsg } from "../utils/errors";
import { uuid } from "../utils/index";

const fixCaptionNull = (data) => {
  // caption 有时为 null，有时为空字符串，这里将其统一为空字符串
  data.results = data.results.map((post) => {
    if (isNil(post.caption)) {
      return { ...post, caption: "" };
    } else {
      return post;
    }
  });
};

export const POST_LIMIT = 15;
export async function loginTw() {
  const oauth = `oauth_nonce="K7ny27JTpKVsTgdyLdDfmQQWVLERj2zAK5BslRsqyw"`;
  loginTwRes({
    oauth,
  });
}
/**
 * 獲取
 * @param startTime
 * @param endTime
 * @returns {Promise<void>}
 */
export async function list({ startTime, endTime, timezone }) {
  const post_time__gte = startTime.utc().format();
  const post_time__lte = endTime.utc().format();
  const { data } = await listRes({
    post_time__gte,
    post_time__lte,
  });
  for (let i = 0; i < data.results.length; i++) {
    if (data.results[i].media_type === 90 && data.results[i].story_url) {
      // 如果存在story url则说明是fb url 替换url中的图片
      const p = await getFbUrl({
        url: data.results[i].story_url,
      });
      if (p.image) {
        data.results[i].cover_url = p.image[0].url;
      }
    }
  }

  fixCaptionNull(data);

  // 对返回结果根据post 时间进行分钟
  let group = formatPostInfo({
    data: data.results,
    timezone,
  });
  // 增加fb url逻辑
  return group;
}

/**
 * 统一格式化post数据
 * @param data post列表
 * @param timezone 时区(用于分组时间)
 */
export function formatPostInfo({ data, timezone }) {
  let list = data.map((item) => new Post(item));
  // 计算时间
  list.forEach((item) => {
    item.postTimeStr = item.postTime.tz(timezone).format("HH:mm");
    item.deleteTimeStr = item.deleteTime
      ? item.deleteTime.tz(timezone).format("HH:mm")
      : "";
  });
  // 对返回结果根据post 时间进行分钟
  let group = [];
  list.forEach((item) => {
    // 获取发送时间
    const itemPostTime = item.postTime.tz(timezone).format("YYYY-MM-DD");
    // 获取该发送时间对应分组
    const groupItem = group.find((g) => g.postTime === itemPostTime);
    item.isVideo = item.mediaList.findIndex((m) => m.type === 2) !== -1;
    // 分组存在则直接添加
    if (groupItem) {
      groupItem.items.push(item);
    } else {
      // 不存在直接初始化分组信息
      group.push({
        postTime: itemPostTime,
        items: [item],
      });
    }
  });
  return group;
}

/**
 * 获取Schedule列表数据
 * @param offset 页码偏移
 * @param reverse 排序方式 是否按 post_time 正序排列
 * @param type 类型 post story 为空则查所有
 */
export async function getScheduleList({
  offset,
  limit = POST_LIMIT,
  reverse,
  type,
}) {
  let media_type = null;
  if (type === "post") {
    media_type = "1,2,8";
  }
  const { data } = await listRes({
    offset,
    limit,
    reverse,
    media_type,
  });

  fixCaptionNull(data);

  data.results.forEach((item) => {
    formatSchedule(item);
  });
  return data;
}

export function formatSchedule(item) {
  const timezone = store.getters[TIMEZONE];
  item.time = moment.tz(item.post_time, timezone).format("MMM DD YYYY, HH:mm");
  item.shortTime = moment.tz(item.post_time, timezone).format("MMM DD, HH:mm");
  item.coverUrl = item.cover_url; // 格式化coverUrl
  item.from = "edit"; // 添加字段代表来源
}

/**
 * 获取Posted列表数据media_type
 * @param offset 页码偏移
 * @param timezone 时区
 */
export async function getPostedList({ offset, limit = POST_LIMIT }) {
  const { data } = await postedListRes({
    offset,
    limit,
  });
  return data;
}

/**
 * 添加story
 * @param form 填写的表单
 * @param image 图片
 * @param repeatTime 循环时间
 */
export async function addStoryPhoto({ form, image, repeatTime }) {
  const result = form.publisherIds.map((p) => {
    return {
      publisherId: p,
      items: [],
    };
  });
  for (let repeatIndex in repeatTime) {
    const repeat = repeatTime[repeatIndex];
    for (let index in form.publisherIds) {
      const publisherId = form.publisherIds[index];
      const img = image;
      const postTime = moment.tz(repeat.postTime, form.tzName);
      const storyForm = {
        media_type: 3,
        cover_key: img.coverKey,
        post_time: postTime.format(),
        tz_name: form.tzName,
        add_to_publishers: form.publisherIds,
        medias: [
          {
            key: img.key,
            type: img.type,
            cover_key: img.coverKey,
            story_mentions: img.story_mentions,
            story_hashtags: img.story_hashtags,
            location_sticker: img.location_sticker,
          },
        ],
        story_url: form.story_url,
      };
      if (img.location_sticker) {
        storyForm.location = form.story_location;
      }
      if (img.story_hashtags.length > 0) {
        storyForm.caption = form.story_caption;
      }
      // 如果填写删除时间则格式化时间
      if (repeat.afterTime) {
        const after = moment(repeat.afterTime, "HH:mm");
        const times = after.hours() * 60 + after.minutes();
        const delTime = postTime.clone().add("m", times);
        storyForm.delete_time = delTime.format();
      }
      let info;
      // 判断form中是否存在id，如果存在则说明是修改
      if (form.id === undefined) {
        info = await addPostRes({
          form: storyForm,
          publisherId,
        });
      } else {
        info = await editPostRes({
          form: storyForm,
          publisherId,
          id: form.id,
        });
      }
      formatSchedule(info.data);
      result.find((r) => r.publisherId === publisherId).items.push(info.data);
    }
  }
  await updateUserInfo({});
  return result;
}

// 计算时间
function formatTime(date, tzName) {
  return moment.tz(date, tzName).format();
}

/**
 * 提交photo post
 * @param form 表单数据
 * @param images 发送的图片
 * @param repeatTime repeat
 * @param reload 是否更新登录人信息
 */
export async function addPostPhoto({
  form,
  images,
  repeatTime,
  reload = true,
}) {
  const result = form.publisherIds.map((p) => {
    return {
      publisherId: p,
      items: [],
    };
  });
  for (let repeatIndex in repeatTime) {
    const repeat = repeatTime[repeatIndex];
    for (let index in form.publisherIds) {
      const publisherId = form.publisherIds[index];
      // 计算media_type类型 多选为 1: photo, 2: video, 3 story 8: album 90:fb url
      let media_type;
      if (images.length === 1) {
        media_type = images[0].type;
      } else if (images.length === 0) {
        media_type = 90;
      } else {
        // 发送多张为album
        media_type = 8;
      }
      // 如果存在则说明是fb url 那么media type = 90
      if (form.story_url) {
        media_type = 90;
      }
      const postForm = {
        caption: form.caption,
        location: form.location,
        story_url: form.story_url,
        media_type,
        cover_key: images[0] ? images[0].coverKey : "",
        post_time: formatTime(repeat.postTime, form.tzName),
        tz_name: form.tzName,
        add_to_publishers: form.publisherIds,
        medias: images.map((m) => {
          let usertags = m.usertags.map((usertag) => {
            const tag = {
              position: usertag.position,
              user_id: usertag.user_id,
              username: usertag.username,
              profile_pic_url: usertag.profile_pic_url,
              is_verified: usertag.isVerified,
              full_name: usertag.full_name,
            };
            if (tag.position && tag.position.length === 2) {
              if (tag.position[0] < 0) {
                tag.position[0] = 0;
              }
              if (tag.position[1] < 0) {
                tag.position[1] = 0;
              }
              tag.x = tag.position[0];
              tag.y = tag.position[1];
            }
            return tag;
          });
          return {
            key: m.key,
            type: m.type,
            cover_key: m.coverKey,
            product_tags: m.product_tags,
            usertags,
          };
        }),
        first_comment: form.firstComment,
      };
      // 如果填写删除时间则格式化时间
      if (repeat.deleteTime) {
        postForm.delete_time = formatTime(repeat.deleteTime, form.tzName);
      }
      // 判断如果为group账号则清空comment字段
      const postPublisher = store.getters[
        CURRENT_USER_INFO_SIMPLE
      ].linkedInstagramList.find((l) => l.publisherId === publisherId);
      if (postPublisher && postPublisher.socialNetwork === 3) {
        postForm.first_comment = "";
      }
      console.log("adfaf", postForm);
      let info;
      // 判断form中是否存在id，如果存在则说明是修改
      if (form.id === undefined) {
        info = await addPostRes({
          form: postForm,
          publisherId,
        });
      } else {
        info = await editPostRes({
          form: postForm,
          publisherId,
          id: form.id,
        });
      }
      formatSchedule(info.data);
      result.find((r) => r.publisherId === publisherId).items.push(info.data);
    }
  }
  if (reload) {
    await updateUserInfo({});
  }
  return result;
}

/**
 * 删除post
 * @param id 需要删除的Post id
 */
export async function delPost({ id }) {
  const { data } = await delPostRes({
    ids: [id],
  });
  return data;
}

/**
 * 从 Instagram 删除该 post
 * @param pk
 * @returns {*}
 */
export async function removePost({ pk }) {
  const { data } = await removePostRes({
    pk,
  });
  return data;
}

/**
 * 马上发布
 * @param ids
 */
export async function postNow({ id, publisherId }) {
  const { data } = await postNowRes({
    id,
    publisherId,
  });
  updateUserInfo({});
  return data;
}

/**
 * 将数据格式化成表单所需
 * @param detail
 */
export function formatFormInfo({ detail }) {
  // 初始化表单
  let info = {};
  // 专门为no text 添加的逻辑
  if (!detail) {
    info.images = [];
    info.form = emptyScheduleForm();
    return info;
  }
  // 说明是选择的是media
  if (detail.from === "add") {
    info.images = [detail];
    info.form = emptyScheduleForm();
    // 同时初始化form信息
  } else if (detail.from === "edit") {
    // 说明是选择的是saved
    info.images = detail.images;
    let form = emptyScheduleForm();
    form.caption = detail.form.caption;
    form.firstComment = detail.form.firstComment;
    form.postTime = detail.form.postTime;
    form.id = detail.form.id;
    info.form = form;
  }
  return info;
}

export function emptyScheduleForm() {
  const timezone = store.getters[TIMEZONE] || currentName;
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const form = {
    publisherIds: [currentPublisher.publisherId],
    caption: "",
    postTime: moment().tz(timezone).add("m", 5).format("YYYY-MM-DD HH:mm:ss"), // 默认时间当前时间加5分钟
    deleteTime: "",
    tzName: timezone,
    location: null,
    firstComment: "",
    story_url: "",
    afterTime: "",
    repeatType: "Never",
  };
  return form;
}

/**
 * 获取最近20条default post time
 * @param type 发送类型 post story
 * @param publisherId 发送用户的publisherId
 * @param tzName 时区
 */
export function getDefaultPostTimes({ type, publisherId }) {
  const postTimes = [];
  // 获取当前default time 时间
  const selectPublisher = store.getters[
    CURRENT_USER_INFO_SIMPLE
  ].linkedInstagramList.find((link) => link.publisherId === publisherId);
  let defaultTimeInfo;
  if (type === "post") {
    defaultTimeInfo = selectPublisher.defaultPostTime;
  } else if (type === "story") {
    defaultTimeInfo = selectPublisher.defaultPostStoryTime;
  }
  // 设置默认发送时间
  const defaultTime = Lockr.get(`${type}_${publisherId}`, {
    send: false,
  });
  defaultTime.id = `${type}_${publisherId}`;
  defaultTime.tzName = defaultTimeInfo.timezone;
  defaultTime.open = defaultTimeInfo.enabled;
  defaultTime.repeat = defaultTimeInfo.repeat;
  defaultTime.times = defaultTimeInfo.times;
  // 获取上次发送时间
  // 获取上次发送时间(如果没有默认当前时间)
  let beforeSendTime = defaultTime.sendTime
    ? moment(defaultTime.sendTime)
    : moment();
  // 如果上次时间少于当前时间则更新到当前时间
  if (beforeSendTime.isBefore(moment())) {
    beforeSendTime = moment();
  }
  beforeSendTime = beforeSendTime.tz(defaultTime.tzName);
  // default post time分2种模式daily:0 和custom:1
  // 如果是daily模式，则将数据结构转化成custom相同
  let frequency = [];
  if (
    defaultTimeInfo.frequencyType === 0 ||
    defaultTimeInfo.frequencyType === undefined
  ) {
    defaultTimeInfo.repeat.forEach((r) => {
      frequency.push({
        week: r,
        times: defaultTimeInfo.times,
      });
    });
  } else {
    frequency = defaultTimeInfo.customFrequency;
  }
  // 计算获取最近可发送的时间,addDay是用于计算在上次发送时间基础上增加几天，毕竟不见得当天还有可发送时间
  let addDay = 0;
  // let nextDateTime = null // 下次发送的时间
  while (true) {
    const date = beforeSendTime.clone().add(addDay, "d");
    // 查看当前日期中是否存在可发送的时间
    let sendWeek = date.weekday();
    // 特殊处理 接口中要求0 是周日
    if (sendWeek === 7) {
      sendWeek = 0;
    }
    const weekInfo = frequency.find((f) => f.week === sendWeek);
    // 当前周没有则跳出循环
    if (!weekInfo) {
      break;
    }
    const nextTime = weekInfo.times
      .filter(
        // 过滤掉未开启的时间
        (t) => t.enabled
      )
      .map((m) => m.time)
      .find((time) => {
        const timeItem = date
          .clone()
          .tz(defaultTime.tzName)
          .hour(time.split(":")[0])
          .minute(time.split(":")[1]);
        return timeItem.isAfter(beforeSendTime);
      });
    // 如果能获取到下一次的发送时间则跳出当前循环，如果找不到则尝试获取明天
    if (nextTime) {
      // nextDateTime = date.hour(nextTime.split(':')[0]).minute(nextTime.split(':')[1])
      break;
    } else {
      addDay = addDay + 1;
    }
  }
  // 获取到下一次发送的确切日期，那么久获取最近20条的post time 时间
  while (postTimes.length < 21) {
    const postTime = beforeSendTime.clone().add(addDay, "d");
    // 查看当前日期中是否存在可发送的时间
    let sendWeek = postTime.weekday();
    // 特殊处理 接口中要求0 是周日
    if (sendWeek === 7) {
      sendWeek = 0;
    }
    const weekInfo = frequency.find((f) => f.week === sendWeek);
    // 当前周没有则跳出循环
    if (weekInfo) {
      const nextTimes = weekInfo.times
        .filter(
          // 过滤掉未开启的时间
          (t) => t.enabled
        )
        .map((m) => m.time)
        .filter((time) => {
          const timeItem = postTime
            .clone()
            .tz(defaultTime.tzName)
            .hour(time.split(":")[0])
            .minute(time.split(":")[1]);
          return timeItem.isAfter(beforeSendTime);
        });
      nextTimes.forEach((nextTime) => {
        const time = postTime
          .clone()
          .hour(nextTime.split(":")[0])
          .minute(nextTime.split(":")[1]);
        postTimes.push(time);
      });
    }
    addDay = addDay + 1;
  }
  return postTimes;
}

/**
 * 验证当前post 发送是否可行
 * [{
    publisherId: '', // 发送的publisher
    num: 1 // 发送的数量
  }]
 */
export async function validatePost({ postList }) {
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  // 获取当前剩余可添加的unlimited用户
  let premiumPublisherRemaining = user.premiumPublisherRemaining;
  let needAddUser = false;
  postList.forEach((post) => {
    // 找到当前发送对应的publisher
    const publisher = user.linkedInstagramList.find(
      (link) => link.publisherId === post.publisherId
    );
    // 计算遍历的publisher是否可以完成发送
    if (publisher.autopostRemaining < post.num) {
      needAddUser = true;
      if (!publisher.wasPremium || user.free) {
        // 发现数量不足，且不是老账号则说明需要占用一个unlimited 账号数量
        premiumPublisherRemaining -= 1;
      }
    }
  });
  if (premiumPublisherRemaining < 0) {
    let text = "";
    if (postList.length > 1) {
      // 多账号发送提示
      text =
        "No more free schedules for some of your Instagram accounts. Upgrade your plan to get unlimited schedules.";
    } else {
      // 单账号发送提示
      text =
        "No more free schedules. Upgrade your plan to get unlimited schedules.";
    }
    debugger;
    app.$confirm
      .show({
        title: "Schedules Limit Reached",
        text,
        yesText: app.$t("common.upgrade"),
      })
      .then(() => {
        // 升级的时候关闭schedule
        app.$bus.$emit("closeScheduleForm");
        app.$router.push({
          name: "UpgradePage",
        });
      });
    // 因需要升级所以无法发送成功
    return Promise.resolve(false);
  } else {
    // 发现需要添加新用户且成功了则添加unlimited用户
    if (needAddUser) {
      let loading = app.$loading();
      try {
        // 当前发送用户和当前unlimited 用户做并集
        let unlimitedPublisherIds = user.linkedInstagramList
          .filter((link) => link.isUnlimited)
          .map((link) => link.id);
        let postPublisherIds = postList.map((p) => p.id);
        const allPublisherIds = new Set([
          ...unlimitedPublisherIds,
          ...postPublisherIds,
        ]);
        await mulModifyUnlimited({
          ids: Array.from(allPublisherIds),
        });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    }
    // 查看此次发送是可以正常发送(autopost数量充足)
    return Promise.resolve(true);
  }
}

/**
 * 提交表单
 *
 * @export
 * @param item 提交的数据
 * @param type 发送的类型
 */
export async function postForm({ item, type }) {
  // 2020.6.8 ins caption增加一个正则全文替换1
  if (item.form.type === "instagram") {
    item.form.caption = item.form.caption
      .replace(/\n/g, "\u2800\n")
      .replace(/(\u2800)+/g, "\u2800");
  }
  let images = [];
  // 裁切图片
  if (item.mediaList.length !== 0) {
    images = await cropImage({
      cropImages: item.mediaList,
      imgChange: item.form.imgChange,
    });
  }
  let result;
  // 添加post样式
  if (type === "post") {
    result = await addPostPhoto({
      form: item.form,
      repeatTime: item.repeatTime,
      images,
      reload: false,
    });
  } else {
    result = await addStoryPhoto({
      form: item.form,
      repeatTime: item.repeatTime,
      image: images[0],
    });
  }
  return result;
}

/**
 * 格式化post 的表单数据
 *
 * @export
 * @param {any} {forms}
 */
export function initPostFormData({ forms, id }) {
  let formUuid = uuid();
  if (id) {
    formUuid = id;
  }
  const all = [];
  forms.forEach((f) => {
    f.repeatTime.forEach((time) => {
      f.form.publisherIds.forEach((publisherId) => {
        const upload = _.cloneDeep(f);
        upload.form.postTime = time.postTime;
        upload.form.deleteTime = time.deleteTime;
        upload.form.tzName = time.tzName;
        upload.uuid = formUuid;
        upload.repeatTime = [time];
        upload.form.publisherIds = [publisherId];
        all.push(upload);
      });
    });
  });
  return all;
}
/**
 * 获取验证的post信息
 * @param token url上的token
 * @returns {*}
 */
export async function getPostBy({ token }) {
  const { data } = await getPostByRes({
    token,
  });
  return data;
}
/**
 * 审核信息
 * @param token url上的token
 * @param status 评审状态 2：接受，3：拒绝
 * @returns {*}
 */
export async function approvePostBy({ token, status }) {
  const { data } = await approvePostByRes({
    token,
    status,
  });
  return data;
}
export async function getFbUrl({ url }) {
  let address = url;
  // 防止用户没写http
  if (url.substr(0, 4) !== "http") {
    address = `http://${address}`;
  }
  return new Promise((resolve, reject) => {
    const result = sessionStorage.getItem(address);
    let resultObj = null;
    // 判断是否存在历史记录
    if (result) {
      resultObj = JSON.parse(result);
      // 如果历史记录是错误，则重新尝试请求
      if (resultObj.error) {
        resultObj = null;
      }
    }
    if (resultObj) {
      resolve(resultObj);
    } else {
      // 随便查找一个fb的token
      const publisher = store.getters[
        CURRENT_USER_INFO_SIMPLE
      ].linkedInstagramList.find(
        (l) =>
          !l.isMember &&
          l.status !== 2 &&
          (l.socialNetwork === 2 || l.socialNetwork === 3)
      );
      const token = publisher.userToken;
      /* eslint-disable no-undef */
      FB.api(
        `?id=${encodeURIComponent(address)}&access_token=${token}&scrape=true`,
        "POST",
        {
          fields: "engagement",
        },
        function (response) {
          sessionStorage.setItem(address, JSON.stringify(response));
          resolve(response);
        }
      );
    }
  });
}
